// components/ProtectedRoute.js
import { useAuth } from '../auth/Login';
import { Navigate, useLocation } from 'react-router-dom';

function ProtectedRoute({ children, requiredAction }) {
  const { user, isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if user has the required action
  if (requiredAction) {
    const hasAction = user?.Actions?.some(action => 
      action.Name.toLowerCase() === requiredAction.toLowerCase()
    );
    
    // If user doesn't have the required action
    if (!hasAction) {
      // Redirect to dashboard with access denied message
      return <Navigate to="/dashboard" state={{ message: "You don't have permission to access this page" }} replace />;
    }
  }

  return children;
}

export default ProtectedRoute;